import React, { useRef, useState, useEffect } from "react";
import "../css/style.css";
import "../css/bootstrap.css";
import { Link, useLocation } from "react-router-dom";

const Slider = () => {
  const scrollRef = useRef(null);
  const location = useLocation();

  // slider items (moved outside JSX)
  const items = [
    {
      href: "home",
      img: "img/shop-category/category-3.png",
      title: "All Steps",
    },
    {
      href: "dairy-farm",
      img: "img/shop-category/category-4.png",
      title: "Dairy Farm",
    },
    {
      href: "milk-grading",
      img: "img/shop-category/category-5.png",
      title: "Milk Grading",
    },
    {
      href: "quality-check",
      img: "img/shop-category/category-6.png",
      title: "Quality Check",
    },
    {
      href: "manufacturing",
      img: "img/shop-category/category-7.png",
      title: "Manufacturing",
    },
    {
      href: "distribution",
      img: "img/shop-category/category-8.png",
      title: "Distribution",
    },
    {
      href: "it-is-you",
      img: "img/new-box.png",
      title: "It's You",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(() => {
    const savedIndex = localStorage.getItem("activeSliderIndex");
    return savedIndex !== null ? Number(savedIndex) : 0;
  });

  /* IMPORTANT PART — detect page change */
  useEffect(() => {
    const currentPath = location.pathname.replace("/", "");

    const foundIndex = items.findIndex(
      (item) => item.href === currentPath
    );

    if (foundIndex !== -1) {
      setActiveIndex(foundIndex);
      localStorage.setItem("activeSliderIndex", foundIndex);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (scrollRef.current) {
      const activeItem = scrollRef.current.children[activeIndex];

      if (activeItem) {
        activeItem.scrollIntoView({
          behavior: "smooth",
          inline: "center",   // keeps selected in middle
          block: "nearest",
        });
      }
    }
  }, [activeIndex]);


  return (
    <div className="bg-white py-3 slider-wrapper">
      <div className="container">
        <div className="row">
          <div
            className="col-12 ps-lg-1 pe-lg-3 ps-sm-1 pe-sm-3 pe-0 d-flex overflow-auto hide-scrollbar"
            ref={scrollRef}
            style={{ gap: "0rem" }}
          >
            {items.map((item, index) => (
              <div
                className="shop-item mx-2 flex-shrink-0 text-center"
                key={index}
                style={{ width: "69px" }}
                onClick={() => {
                  setActiveIndex(index);
                  localStorage.setItem("activeSliderIndex", index);
                }}
              >
                <Link
                  to={`/${item.href}`}
                  className="link-dark"
                  style={{ textDecoration: "none" }}
                >
                  <img
                    src={item.img}
                    alt=""
                    className="rounded-pill mb-1"
                    style={{
                      width: "69px",
                      height: "69px",
                      border:
                        activeIndex === index
                          ? "3px solid #198754"
                          : "3px solid transparent",
                      boxShadow:
                        activeIndex === index
                          ? "0 0 0 2px rgba(25,135,84,0.3)"
                          : "none",
                    }}
                  />
                  <div style={{ fontSize: "12px", lineHeight: "1.2" }}>
                    {item.title}
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="underline2 mt-2"></div>
      </div>
    </div>
  );
};

export default Slider;
